import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {Counter} from './Counter/Counter'

type Props = {
  unitId: string
}

export const Guest = ({unitId}: Props) => {
  const unit = VentrataDataProvider.useUnit(unitId, 'optional')

  return (
    <div className="flex justify-between items-center">
      <div className="flex flex-col ">
        <div className="font-bold">{unit.title}</div>
        <div className="font-sm text-french-blue-020">{unit.subtitle}</div>
      </div>

      <div className="flex gap-6 items-center text-lg">
        <Counter unit={unit} />
      </div>
    </div>
  )
}
